import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  standalone: false,
  selector: "history-validation-cell",
  templateUrl: "./history-validation-cell.component.html",
  styleUrls: ["./history-validation-cell.component.scss"]
})
export class HistoryValidationCellComponent implements OnInit {

  public params: any;
  public validationSum: any;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params;
  }

  /** True for the pinned param-name (row-header) column. */
  get isParamLabelCell(): boolean {
    return this.params?.colDef?.field === "param.name";
  }

  /** Displayed value — uses valueFormatted when available. */
  getValueToDisplay(): any {
    return this.params?.valueFormatted ?? this.params?.value;
  }

  /** True when this row can be edited (has MODIFY permission and grid is valid). */
  get isRowEditable(): boolean {
    const context = this.params?.context;
    if (context && typeof context.isRowEditable === "function") {
      return context.isRowEditable(this.params?.node) === true;
    }
    return false;
  }

  get rowEditAriaLabel(): string {
    const rowLabel = this.translate.instant(this.params?.data?.param?.label ?? "");
    return this.translate.instant("plan.detail.edit.row.button.aria", { row: rowLabel });
  }

  get rowEditTooltip(): string {
    const rowLabel = this.translate.instant(this.params?.data?.param?.label ?? "");
    return this.translate.instant("plan.detail.edit.row.button.tooltip", { row: rowLabel });
  }

  startRowEdit(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const context = this.params?.context;
    if (context && typeof context.startRowEditing === "function") {
      context.startRowEditing(this.params?.node);
    }
  }

  get isValidIndicator(){
    let context = this.params.context;
    //return context.isGridValid()==false;
    return context.isGridValid()==false &&
      context.isValidCell(this.params,this.params.colDef.field)==false &&
      this.params.api.getFocusedCell() &&
      this.params.api.getFocusedCell().rowIndex==(this.params.node?.rowIndex ?? this.params.rowIndex) &&
      this.params.api.getFocusedCell().column.colId==this.params.column.colId
  }
  get validationMessage(){
    let context = this.params.context;

    return this.params.data.metadata.validator.msg;
  }

  refresh(){
    return false;
  }


}
